module.exports = __webpack_public_path__ + "static/media/1 dove dagger tattoo sleeve black and grey rose realistic realism .1280x1418.80e5bd4f.webp";